import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { CATEGORIES } from "../data/site";
import { Reveal, StaggerGroup, StaggerItem } from "../components/Reveal";

const Products = () => (
  <div data-testid="page-products" className="bg-background">
    {/* HEADER */}
    <section className="border-b border-border">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 lg:py-24">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-12 bg-[#C8102E]" />
            <span className="text-xs uppercase tracking-overline font-bold text-muted-foreground">
              Product Categories
            </span>
          </div>
          <h1 className="font-display font-black uppercase text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.95] max-w-4xl">
            Every part your <br />
            <span className="text-[#C8102E]">vehicle demands.</span>
          </h1>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">
            A comprehensive inventory covering engine, drivetrain, chassis,
            electrical and consumables — for Mahindra, Maruti Suzuki and Tata
            vehicles. Enquire for availability and pricing.
          </p>
        </Reveal>
      </div>
    </section>

    {/* GRID */}
    <section className="py-14 lg:py-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <StaggerGroup className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 border-t border-l border-border">
          {CATEGORIES.map((c) => (
            <StaggerItem
              key={c.key}
              id={c.key}
              className="group border-r border-b border-border bg-card overflow-hidden"
              data-testid={`product-card-${c.key}`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={c.image}
                  alt={c.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-5 lg:p-6">
                <div className="text-[11px] uppercase tracking-overline text-muted-foreground">
                  Category
                </div>
                <h3 className="mt-1.5 font-display font-bold text-lg lg:text-xl tracking-tight">
                  {c.name}
                </h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                  {c.description}
                </p>
                <Link
                  to={`/contact?part=${encodeURIComponent(c.name)}`}
                  data-testid={`products-enquire-${c.key}`}
                  className="mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-overline text-[#C8102E] hover:gap-3 transition-all duration-200"
                >
                  Enquire Now <ChevronRight className="h-3.5 w-3.5" />
                </Link>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>

    {/* CTA */}
    <section className="py-16 bg-[#111111] text-white">
      <div className="mx-auto max-w-4xl px-5 sm:px-8 text-center">
        <h3 className="font-display font-black text-3xl md:text-4xl uppercase tracking-tighter">
          Didn&apos;t find the exact part?
        </h3>
        <p className="mt-4 text-[#A7A9AC]">
          Send us your vehicle brand, model and requirement — our team will
          source it for you.
        </p>
        <Link
          to="/contact"
          className="mt-8 inline-flex items-center gap-2 h-12 px-6 bg-[#C8102E] text-white text-sm font-bold uppercase tracking-overline hover:bg-[#A00D24] transition-colors duration-200"
          data-testid="products-cta-contact"
        >
          Send Enquiry <ChevronRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  </div>
);

export default Products;
